<template>
  <page-title pageTitle="Supplier Invoice" title="Edit Supplier Invoice" />
  <distributor-invoices-form
    v-if="distributorInvoice.id"
    :distributorInvoice="distributorInvoice"
    :submitFunction="editDistributorInvoice"
  />
  <div v-else class="card">
    <LoadingModal v-if="loading" />
    <div v-else-if="error" class="card-body">
      {{ error }}
    </div>
    <div v-else class="card-body">The Supplier Invoice doesn't exist</div>
  </div>
</template>

<script>
import PageTitleComponent from "@/components/shared/PageTitle";
import DistributorInvoicesForm from "@/components/distributorInvoices/DistributorInvoicesForm";
import LoadingModalComponent from "@/components/utils/LoadingModal";

export default {
  name: "EditDistributorInvoiceView",
  components: {
    PageTitle: PageTitleComponent,
    DistributorInvoicesForm: DistributorInvoicesForm,
    LoadingModal: LoadingModalComponent,
  },
  data() {
    return {
      id: -1,
    };
  },
  computed: {
    distributorInvoice() {
      return this.$store.getters.distributorInvoice;
    },
    error() {
      return this.$store.getters.distributorInvoicesError;
    },
    loading() {
      return this.$store.getters.distributorInvoicesLoading;
    },
  },
  methods: {
    async editDistributorInvoice(distributorInvoice) {
      await this.$store.dispatch("editDistributorInvoice", distributorInvoice);
      this.$router.push("/distributors/invoices");
    },
  },
  async created() {
    this.id = parseInt(this.$route.params.id);
    await this.$store.dispatch("getDistributorInvoice", this.id);
  },
  unmounted() {
    this.$store.dispatch("resetDistributorInvoices", this.id);
  },
};
</script>

<style scoped></style>
